<template>
  <div v-editable="blok" class="heading-section">
    <h1 class="main_title" v-if="blok.main_title!=''">{{ blok.main_title }}</h1>
    <h4 class="sub_title" v-if="blok.sub_title!=''">{{ blok.sub_title }}</h4>
  </div>
</template>
<script>
export default {
    name: 'heading_section',
    props: ['blok']
}
</script>